const mapStaticTexts = (texts) => {
    return texts.nodes.reduce((obj, { text, name }) => {
      obj[name] = text;
      return obj;
    }, {});
  };
  
  export default mapStaticTexts;
  